import React from 'react';
import { Arrow } from './constants';
import './CrazyArrow.scss';

const CrazyArrow = (props) => {
    const getRotationValue = (direction) => {
        switch (direction) {
            case "up":
                return "-90deg";
            case "down":
                return "90deg";
            case "left":
                return "180deg";
            case "right":
                return "0deg"
        }
    }
    return (
        <div className="crazy-question">
            <div>
                <p >
                    <div style={{ transform: `rotate(${getRotationValue(props.specs?.directionTop)})`, }}><Arrow fill={props.specs.topColor} /></div>
                </p>
            </div>
            <div>
                <p style={{
                    color: props.specs.bottomColor,
                }}>
                    <div style={{ transform: `rotate(${getRotationValue(props.specs?.directionBottom)})`, }}><Arrow fill={props.specs.bottomColor} /></div>
                </p>
            </div>
            <h1>{props.specs.text}</h1>
        </div>
    );
}

export default CrazyArrow;
// {
//     topColor: colors.red,
//     bottomColor: colors.yellow,
//     directionTop: 'left',
//     directionBottom: 'right',
//     match: 'direction',
//     with: 'top',
//     text: 'left',
//     answer: true,
//     options: [
//         {
//             name: "Match",
//             value: true,
//         },
//         {
//             name: "Not Match",
//             value: false,
//         }
//     ]
// }